module.exports = __webpack_public_path__ + "img/Islamic StudiesEx.1f4c2d4b.svg";